export default __webpack_public_path__ + "static/Preliminary engagement - Feb 2021-f77fe478921c612e1a453de3b7ffbcc1.pdf";